export default {
  SET_COMPANY (state, company) {
    state.company = company
  },
  REMOVE_RECORD (state, itemId) {
    const companyIndex = state.company.findIndex((u) => u.id === itemId)
    state.company.splice(companyIndex, 1)
  }
}
